import React from "react";
import ImageV2 from "../image/image.v2";


export default class MapImage extends React.Component<ImageMapProps> {
    static TOKEN = process.env.MAPBOX_TOKEN || "pk.eyJ1Ijoic3BvdGxpbyIsImEiOiJjbGZjOTN0ZmYwNGZtM3BwMDJ4ZGYxeXhlIn0.Cm5ThR-UvcADRTOOD_RV6Q";

    private src(width: number = 1200, height: number = 124) {
        const zoom = this.props.zoom;
        const lat = this.props.latitude;
        const lng = this.props.longitude;
        const maptype = "outdoors-v11";
        return `https://api.mapbox.com/styles/v1/mapbox/${maptype}/static/${lng},${lat},${zoom},0,0/${width}x${height}?attribution=false&logo=false&access_token=${MapImage.TOKEN}`
    }

    render() {
        const {desktopHeight, desktopWidth, mobileHeight, mobileWidth} = this.props;
        return <>
            <ImageV2 className="w-full h-[154px] inline-flex md:hidden" useImageKit={false} src={this.src(mobileHeight, mobileWidth)}></ImageV2>
            <ImageV2 className="w-full h-[154px] hidden md:inline-flex" useImageKit={false} src={this.src(desktopWidth, desktopHeight)}></ImageV2>
        </>
    }
}